"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_i18next_1 = require("react-i18next");
var shortlink_1 = __importDefault(require("../util/shortlink"));
var url_1 = require("../../../../../app/util/url");
var index_1 = require("../../index");
var validation_1 = require("../../../../../../shared/util/validation");
var ConfigOption_1 = __importStar(require("../../../../widgets/ConfigOption"));
var PrefixableTextField_1 = __importDefault(require("../../../../widgets/PrefixableTextField"));
var TrailingButton_1 = __importDefault(require("./TrailingButton"));
function LongUrlEditor() {
    var _a = __read(react_i18next_1.useTranslation(), 1), t = _a[0];
    var theme = core_1.useTheme();
    var isMobileView = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var drawerStates = index_1.useDrawerState();
    var _b = shortlink_1.default(drawerStates.relevantShortLink), shortLinkState = _b.shortLinkState, shortLinkDispatch = _b.shortLinkDispatch;
    var originalLongUrl = url_1.removeHttpsProtocol((shortLinkState === null || shortLinkState === void 0 ? void 0 : shortLinkState.longUrl) || '');
    var _c = __read(react_1.useState(originalLongUrl), 2), editedLongUrl = _c[0], setEditedLongUrl = _c[1];
    return (react_1.default.createElement(ConfigOption_1.default, { title: t('editLink.originalLink'), leading: react_1.default.createElement(PrefixableTextField_1.default, { value: editedLongUrl, onChange: function (event) {
                return setEditedLongUrl(url_1.removeHttpsProtocol(event.target.value));
            }, placeholder: t('editLink.originalLink'), prefix: "https://", error: !validation_1.isValidLongUrl(editedLongUrl, true), helperText: validation_1.isValidLongUrl(editedLongUrl, true)
                ? ' '
                : t('message.error.incorrectURL') }), trailing: react_1.default.createElement(TrailingButton_1.default, { disabled: !validation_1.isValidLongUrl(editedLongUrl, false) ||
                editedLongUrl === originalLongUrl, onClick: function () { return shortLinkDispatch === null || shortLinkDispatch === void 0 ? void 0 : shortLinkDispatch.applyEditLongUrl(editedLongUrl); }, fullWidth: isMobileView, variant: isMobileView ? 'contained' : 'outlined' }, t('button.save')), wrapTrailing: isMobileView, trailingPosition: ConfigOption_1.TrailingPosition.end }));
}
exports.default = LongUrlEditor;
